import { DatapointStatus } from '@netpurpose/types'
import { DatapointStatus as BackendDatapointStatus } from '../../generated/modelling'

export const datapointStatusMap = {
  [DatapointStatus.Accepted]: BackendDatapointStatus.ACCEPTED,
  [DatapointStatus.Created]: BackendDatapointStatus.CREATED,
}
